module.exports = __webpack_public_path__ + "img/yj_recall_bg_bottom.c2b46275.png";